import axios from 'axios';

export const baseUrl = "/api/";

const baseService = axios.create({
    baseURL: baseUrl
});

export default baseService;